export function VendorInvoiceCreditsCtrl ($state, $scope, $translate, workshopAPI) {
  $scope.showVendorInvoiceCredits = !!$scope.credits.length;

  $scope.tableSettings = {
    columns: [
      {
        field : 'vendor_invoice_number',
        header: {
          text: $translate.instant('REPORT_SPACE.FIELD.INVOICE_NUMBER')
        },
      },
      {
        field : 'created_on',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.DATE')
        },
        pipe  : 'date'
      },
      {
        field : 'amount',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.AMOUNT')
        },
        pipe  : 'globalCurrency'
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_CREDITS_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/vendor_credit_application_items/vendor_invoice_credit_count', $scope.invoice.id)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      direction: 'desc',
      enabled  : true,
      field    : 'post_date'
    },
  };

  $scope.onRowDoubleClick = function (credit) {
    workshopAPI.get('/vendor_invoice', [credit.row.vendor_credit_id]).then(function (vendor_invoice) {
      $scope.viewInvoice(vendor_invoice);
    })
  };

  $scope.viewInvoice = function (invoice) {
    $state.go('app.vendor-invoice', {
      vendor_id: invoice.vendor_id,
      id       : invoice.id
    });
  };

  $scope.getCredits = ( params ) => {
    return workshopAPI.get('/vendor_credit_application_items/vendor_invoice_credit_list', [
      $scope.invoice.id,
      params.offset,
      params.pageSize
    ]).then(credits => {
      $scope.credits = credits;

      return credits;
    });
  };
}